/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  padding: ${token('space.400')};
`;

export const Header = styled.div`
  font: ${token('font.heading.xsmall')};
  margin-top: ${token('space.200')};
  align-items: center;
  display: flex;
`;

export const Title = styled.div`
  margin-left: ${token('space.100')};
`;

export const Description = styled.p`
  color: ${token('color.text.subtle', colors.N500)};
`;
